/* eslint-disable */
/* Updated at 2026-06-23T13:26:42Z */
/* File is automatically generated, do not modify it */
export const colors = {
    "light": {
        "theme": {
            "themeFirst": {
                "background": {
                    "myMessageStartGradient": "rgba(237, 255, 206, 1.00)",
                    "myMessageEndGradient": "rgba(237, 255, 206, 1.00)",
                    "startPattern": "rgba(0, 0, 0, 0.10)",
                    "startBackground": "rgba(180, 217, 164, 1.00)",
                    "middleBackground": "rgba(139, 174, 134, 1.00)",
                    "endBackground": "rgba(188, 200, 122, 1.00)",
                    "systemMessage": "rgba(237, 255, 206, 0.65)",
                    "someoneHistogram": "rgba(178, 178, 178, 1.00)",
                    "myHistogram": "rgba(178, 178, 164, 1.00)",
                    "textCounter": "rgba(255, 255, 255, 1.00)",
                    "textMutedCounter": "rgba(255, 255, 255, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(64, 178, 89, 1.00)",
                    "textOrIcon": "rgba(58, 160, 80, 1.00)",
                    "themeAccent": "rgba(58, 160, 80, 1.00)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(64, 178, 89, 1.00)",
                    "hover": "rgba(54, 151, 76, 1.00)",
                    "pressed": "rgba(48, 133, 67, 1.00)",
                    "50%": "rgba(64, 178, 89, 0.50)",
                    "40%": "rgba(64, 178, 89, 0.40)",
                    "30%": "rgba(64, 178, 89, 0.30)",
                    "20%": "rgba(64, 178, 89, 0.20)",
                    "10%": "rgba(64, 178, 89, 0.10)",
                    "forMention": "rgba(64, 178, 89, 0.17)"
                }
            },
            "themeSecond": {
                "background": {
                    "myMessageStartGradient": "rgba(234, 252, 255, 1.00)",
                    "myMessageEndGradient": "rgba(234, 252, 255, 1.00)",
                    "startPattern": "rgba(0, 0, 0, 0.10)",
                    "startBackground": "rgba(127, 181, 199, 1.00)",
                    "middleBackground": "rgba(116, 184, 216, 1.00)",
                    "endBackground": "rgba(177, 216, 244, 1.00)",
                    "systemMessage": "rgba(234, 252, 255, 0.65)",
                    "someoneHistogram": "rgba(178, 178, 178, 1.00)",
                    "myHistogram": "rgba(187, 202, 204, 1.00)",
                    "textCounter": "rgba(255, 255, 255, 1.00)",
                    "textMutedCounter": "rgba(255, 255, 255, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(30, 169, 223, 1.00)",
                    "textOrIcon": "rgba(39, 148, 194, 1.00)",
                    "themeAccent": "rgba(39, 148, 194, 1.00)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(30, 169, 223, 1.00)",
                    "hover": "rgba(37, 139, 184, 1.00)",
                    "pressed": "rgba(32, 123, 162, 1.00)",
                    "50%": "rgba(30, 169, 223, 0.50)",
                    "40%": "rgba(30, 169, 223, 0.40)",
                    "30%": "rgba(30, 169, 223, 0.30)",
                    "20%": "rgba(30, 169, 223, 0.20)",
                    "10%": "rgba(30, 169, 223, 0.10)",
                    "forMention": "rgba(30, 169, 223, 0.15)"
                }
            },
            "themeThird": {
                "background": {
                    "myMessageStartGradient": "rgba(255, 240, 248, 1.00)",
                    "myMessageEndGradient": "rgba(255, 240, 248, 1.00)",
                    "startPattern": "rgba(0, 0, 0, 0.10)",
                    "startBackground": "rgba(227, 179, 231, 1.00)",
                    "middleBackground": "rgba(235, 179, 205, 1.00)",
                    "endBackground": "rgba(242, 179, 182, 1.00)",
                    "systemMessage": "rgba(255, 240, 248, 0.65)",
                    "someoneHistogram": "rgba(178, 178, 178, 1.00)",
                    "myHistogram": "rgba(204, 192, 198, 1.00)",
                    "textCounter": "rgba(255, 255, 255, 1.00)",
                    "textMutedCounter": "rgba(255, 255, 255, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(245, 100, 168, 1.00)",
                    "textOrIcon": "rgba(220, 90, 151, 1.00)",
                    "themeAccent": "rgba(220, 90, 151, 1.00)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(245, 100, 168, 1.00)",
                    "hover": "rgba(208, 85, 143, 1.00)",
                    "pressed": "rgba(208, 85, 143, 1.00)",
                    "50%": "rgba(245, 100, 168, 0.50)",
                    "40%": "rgba(245, 100, 168, 0.40)",
                    "30%": "rgba(245, 100, 168, 0.30)",
                    "20%": "rgba(245, 100, 168, 0.20)",
                    "10%": "rgba(245, 100, 168, 0.10)",
                    "forMention": "rgba(245, 100, 168, 0.15)"
                }
            }
        },
        "background": {
            "01Base": "rgba(255, 255, 255, 1.00)",
            "02Second": "rgba(245, 245, 245, 1.00)",
            "sheetOrModal": "rgba(255, 255, 255, 1.00)",
            "messageScreen": "rgba(180, 217, 164, 1.00)",
            "someoneMessage": "rgba(255, 255, 255, 1.00)",
            "badgeMuted": "rgba(201, 201, 201, 1.00)"
        },
        "system": {
            "dangerDefault": "rgba(224, 97, 65, 1.00)",
            "dangerHover": "rgba(201, 70, 38, 1.00)",
            "dangerPressed": "rgba(176, 62, 34, 1.00)",
            "dangerFocused": "rgba(176, 62, 34, 1.00)",
            "danger40%": "rgba(224, 97, 65, 0.40)",
            "danger30%": "rgba(224, 97, 65, 0.30)",
            "danger20%": "rgba(224, 97, 65, 0.20)",
            "danger10%": "rgba(224, 97, 65, 0.10)",
            "warningDefault": "rgba(220, 155, 28, 1.00)",
            "successDefault": "rgba(64, 178, 89, 1.00)",
            "successHover": "rgba(51, 156, 74, 1.00)",
            "successPressed": "rgba(49, 141, 70, 1.00)",
            "successFocused": "rgba(42, 121, 60, 1.00)",
            "success40%": "rgba(64, 178, 89, 0.40)",
            "success30%": "rgba(64, 178, 89, 0.30)",
            "success20%": "rgba(64, 178, 89, 0.20)",
            "success10%": "rgba(64, 178, 89, 0.10)",
            "infoDefault": "rgba(80, 158, 249, 1.00)",
            "online": "rgba(4, 203, 0, 1.00)"
        },
        "avatarka": {
            "0": "rgba(75, 203, 236, 1.00)",
            "1": "rgba(242, 168, 103, 1.00)",
            "2": "rgba(108, 205, 101, 1.00)",
            "3": "rgba(173, 149, 238, 1.00)",
            "4": "rgba(227, 182, 66, 1.00)",
            "5": "rgba(112, 172, 241, 1.00)",
            "6": "rgba(255, 145, 144, 1.00)",
            "7": "rgba(73, 211, 147, 1.00)",
            "8": "rgba(247, 123, 189, 1.00)",
            "9": "rgba(255, 148, 87, 1.00)",
            "10": "rgba(218, 148, 231, 1.00)",
            "saved": "rgba(186, 186, 186, 1.00)",
            "deactivated": "rgba(186, 186, 186, 1.00)"
        },
        "avatarkaSecond": {
            "0": "rgba(0, 153, 214, 1.00)",
            "1": "rgba(199, 95, 34, 1.00)",
            "2": "rgba(65, 163, 63, 1.00)",
            "3": "rgba(129, 83, 203, 1.00)",
            "4": "rgba(220, 136, 26, 1.00)",
            "5": "rgba(64, 126, 218, 1.00)",
            "6": "rgba(207, 66, 57, 1.00)",
            "7": "rgba(26, 168, 102, 1.00)",
            "8": "rgba(192, 75, 130, 1.00)",
            "9": "rgba(204, 88, 0, 1.00)",
            "10": "rgba(175, 102, 189, 1.00)",
            "saved": "rgba(119, 119, 132, 1.00)",
            "deactivated": "rgba(119, 119, 132, 1.00)"
        },
        "basicColors": {
            "100%": "rgba(0, 0, 0, 1.00)",
            "90%": "rgba(0, 0, 0, 0.90)",
            "80%": "rgba(0, 0, 0, 0.80)",
            "60%": "rgba(0, 0, 0, 0.60)",
            "55%": "rgba(0, 0, 0, 0.55)",
            "50%": "rgba(0, 0, 0, 0.50)",
            "40%": "rgba(0, 0, 0, 0.40)",
            "30%": "rgba(0, 0, 0, 0.30)",
            "25%": "rgba(0, 0, 0, 0.25)",
            "20%": "rgba(0, 0, 0, 0.20)",
            "15%": "rgba(0, 0, 0, 0.15)",
            "10%": "rgba(0, 0, 0, 0.10)",
            "8%": "rgba(0, 0, 0, 0.08)",
            "6%": "rgba(0, 0, 0, 0.06)",
            "4%": "rgba(0, 0, 0, 0.04)",
            "white": {
                "100%": "rgba(255, 255, 255, 1.00)",
                "80%": "rgba(255, 255, 255, 0.80)",
                "70%": "rgba(255, 255, 255, 0.70)",
                "50%": "rgba(255, 255, 255, 0.50)",
                "30%": "rgba(255, 255, 255, 0.30)",
                "20%": "rgba(255, 255, 255, 0.20)"
            },
            "black": {
                "100%": "rgba(0, 0, 0, 1.00)",
                "95%": "rgba(0, 0, 0, 0.95)",
                "80%": "rgba(0, 0, 0, 0.80)",
                "50%": "rgba(0, 0, 0, 0.50)",
                "24%": "rgba(0, 0, 0, 0.24)",
                "16%": "rgba(0, 0, 0, 0.16)",
                "10%": "rgba(0, 0, 0, 0.10)"
            },
            "inverted": {
                "100%": "rgba(255, 255, 255, 1.00)",
                "90%": "rgba(255, 255, 255, 0.90)"
            }
        },
        "vCS": {
            "backgroundAnimation": {
                "movingHightlights": {
                    "blob1": {
                        "start": "rgba(25, 240, 70, 0.85)",
                        "end": "rgba(0, 200, 120, 0.30)"
                    },
                    "blob2": {
                        "start": "rgba(0, 210, 170, 0.75)",
                        "end": "rgba(25, 240, 70, 0.25)"
                    },
                    "blob3": {
                        "start": "rgba(80, 230, 60, 0.70)",
                        "end": "rgba(160, 240, 50, 0.20)"
                    },
                    "blob4": {
                        "start": "rgba(0, 180, 160, 0.60)",
                        "end": "rgba(40, 220, 100, 0.30)"
                    },
                    "blob5": "rgba(0, 255, 180, 0.65)",
                    "blob6": "rgba(20, 160, 80, 0.25)"
                }
            }
        }
    },
    "dark": {
        "theme": {
            "themeFirst": {
                "background": {
                    "myMessageStartGradient": "rgba(58, 104, 69, 1.00)",
                    "myMessageEndGradient": "rgba(40, 79, 50, 1.00)",
                    "startPattern": "rgba(15, 15, 16, 1.00)",
                    "startBackground": "rgba(37, 37, 37, 1.00)",
                    "middleBackground": "rgba(42, 42, 42, 1.00)",
                    "endBackground": "rgba(53, 53, 53, 1.00)",
                    "systemMessage": "rgba(26, 26, 26, 1.00)",
                    "someoneHistogram": "rgba(110, 110, 113, 1.00)",
                    "myHistogram": "rgba(102, 126, 114, 1.00)",
                    "textCounter": "rgba(0, 0, 0, 0.98)",
                    "textMutedCounter": "rgba(0, 0, 0, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(64, 178, 89, 1.00)",
                    "textOrIcon": "rgba(76, 199, 103, 1.00)",
                    "themeAccent": "rgba(255, 255, 255, 0.85)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(64, 178, 89, 1.00)",
                    "hover": "rgba(51, 156, 74, 1.00)",
                    "pressed": "rgba(42, 121, 60, 1.00)",
                    "50%": "rgba(64, 178, 89, 0.50)",
                    "40%": "rgba(64, 178, 89, 0.40)",
                    "30%": "rgba(64, 178, 89, 0.30)",
                    "20%": "rgba(64, 178, 89, 0.20)",
                    "10%": "rgba(64, 178, 89, 0.10)",
                    "forMention": "rgba(255, 255, 255, 0.25)"
                }
            },
            "themeSecond": {
                "background": {
                    "myMessageStartGradient": "rgba(36, 123, 160, 1.00)",
                    "myMessageEndGradient": "rgba(25, 100, 132, 1.00)",
                    "startPattern": "rgba(15, 15, 16, 1.00)",
                    "startBackground": "rgba(17, 26, 35, 1.00)",
                    "middleBackground": "rgba(20, 31, 40, 1.00)",
                    "endBackground": "rgba(22, 42, 57, 1.00)",
                    "systemMessage": "rgba(26, 26, 26, 1.00)",
                    "someoneHistogram": "rgba(110, 110, 113, 1.00)",
                    "myHistogram": "rgba(102, 160, 186, 1.00)",
                    "textCounter": "rgba(255, 255, 255, 1.00)",
                    "textMutedCounter": "rgba(255, 255, 255, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(49, 151, 195, 1.00)",
                    "textOrIcon": "rgba(54, 170, 220, 1.00)",
                    "themeAccent": "rgba(255, 255, 255, 0.90)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(52, 159, 205, 1.00)",
                    "hover": "rgba(34, 131, 173, 1.00)",
                    "pressed": "rgba(30, 115, 151, 1.00)",
                    "50%": "rgba(52, 159, 205, 0.50)",
                    "40%": "rgba(52, 159, 205, 0.40)",
                    "30%": "rgba(52, 159, 205, 0.30)",
                    "20%": "rgba(52, 159, 205, 0.20)",
                    "10%": "rgba(52, 159, 205, 0.10)",
                    "forMention": "rgba(255, 255, 255, 0.25)"
                }
            },
            "themeThird": {
                "background": {
                    "myMessageStartGradient": "rgba(177, 72, 111, 1.00)",
                    "myMessageEndGradient": "rgba(156, 62, 96, 1.00)",
                    "startPattern": "rgba(15, 15, 16, 1.00)",
                    "startBackground": "rgba(70, 32, 51, 1.00)",
                    "middleBackground": "rgba(49, 27, 32, 1.00)",
                    "endBackground": "rgba(66, 46, 56, 1.00)",
                    "systemMessage": "rgba(26, 26, 26, 1.00)",
                    "someoneHistogram": "rgba(110, 110, 113, 1.00)",
                    "myHistogram": "rgba(205, 129, 157, 1.00)",
                    "textCounter": "rgba(255, 255, 255, 1.00)",
                    "textMutedCounter": "rgba(0, 0, 0, 1.00)"
                },
                "accent": {
                    "newBadge": "rgba(220, 81, 132, 1.00)",
                    "textOrIcon": "rgba(245, 102, 156, 1.00)",
                    "themeAccent": "rgba(255, 255, 255, 0.85)",
                    "vKSDefault": "rgba(81, 106, 233, 1.00)",
                    "vKSHover": "rgba(65, 89, 208, 1.00)",
                    "vKSPressed": "rgba(54, 77, 193, 1.00)"
                },
                "primary": {
                    "default": "rgba(220, 81, 132, 1.00)",
                    "hover": "rgba(176, 65, 106, 1.00)",
                    "pressed": "rgba(154, 57, 92, 1.00)",
                    "50%": "rgba(220, 81, 132, 0.50)",
                    "40%": "rgba(220, 81, 132, 0.40)",
                    "30%": "rgba(220, 81, 132, 0.30)",
                    "20%": "rgba(220, 81, 132, 0.20)",
                    "10%": "rgba(220, 81, 132, 0.10)",
                    "forMention": "rgba(255, 255, 255, 0.25)"
                }
            }
        },
        "background": {
            "01Base": "rgba(26, 26, 26, 1.00)",
            "02Second": "rgba(49, 49, 49, 1.00)",
            "sheetOrModal": "rgba(35, 35, 37, 1.00)",
            "messageScreen": "rgba(15, 15, 16, 1.00)",
            "someoneMessage": "rgba(55, 55, 55, 1.00)",
            "badgeMuted": "rgba(72, 72, 72, 1.00)"
        },
        "system": {
            "dangerDefault": "rgba(224, 97, 65, 1.00)",
            "dangerHover": "rgba(203, 82, 52, 1.00)",
            "dangerPressed": "rgba(156, 63, 40, 1.00)",
            "dangerFocused": "rgba(156, 63, 40, 1.00)",
            "danger40%": "rgba(224, 97, 65, 0.40)",
            "danger30%": "rgba(224, 97, 65, 0.30)",
            "danger20%": "rgba(224, 97, 65, 0.20)",
            "danger10%": "rgba(224, 97, 65, 0.10)",
            "warningDefault": "rgba(220, 155, 28, 1.00)",
            "successDefault": "rgba(64, 178, 89, 1.00)",
            "successHover": "rgba(42, 158, 67, 1.00)",
            "successPressed": "rgba(38, 146, 61, 1.00)",
            "successFocused": "rgba(38, 146, 61, 1.00)",
            "success40%": "rgba(82, 193, 106, 0.40)",
            "success30%": "rgba(82, 193, 106, 0.30)",
            "success20%": "rgba(82, 193, 106, 0.20)",
            "success10%": "rgba(82, 193, 106, 0.10)",
            "infoDefault": "rgba(80, 158, 249, 1.00)",
            "online": "rgba(4, 203, 0, 1.00)"
        },
        "avatarka": {
            "0": "rgba(132, 227, 243, 1.00)",
            "1": "rgba(254, 176, 133, 1.00)",
            "2": "rgba(177, 236, 95, 1.00)",
            "3": "rgba(225, 214, 254, 1.00)",
            "4": "rgba(254, 216, 115, 1.00)",
            "5": "rgba(174, 211, 254, 1.00)",
            "6": "rgba(255, 165, 115, 1.00)",
            "7": "rgba(149, 221, 161, 1.00)",
            "8": "rgba(254, 162, 211, 1.00)",
            "9": "rgba(254, 176, 133, 1.00)",
            "10": "rgba(239, 175, 250, 1.00)",
            "saved": "rgba(168, 168, 168, 1.00)",
            "deactivated": "rgba(168, 168, 168, 1.00)"
        },
        "avatarkaSecond": {
            "0": "rgba(41, 101, 128, 1.00)",
            "1": "rgba(172, 80, 28, 1.00)",
            "2": "rgba(83, 127, 35, 1.00)",
            "3": "rgba(104, 65, 183, 1.00)",
            "4": "rgba(169, 116, 46, 1.00)",
            "5": "rgba(63, 106, 172, 1.00)",
            "6": "rgba(248, 67, 22, 1.00)",
            "7": "rgba(57, 125, 63, 1.00)",
            "8": "rgba(158, 63, 108, 1.00)",
            "9": "rgba(171, 78, 55, 1.00)",
            "10": "rgba(113, 55, 124, 1.00)",
            "saved": "rgba(119, 119, 132, 1.00)",
            "deactivated": "rgba(119, 119, 132, 1.00)"
        },
        "basicColors": {
            "100%": "rgba(255, 255, 255, 1.00)",
            "90%": "rgba(255, 255, 255, 0.90)",
            "80%": "rgba(255, 255, 255, 0.80)",
            "60%": "rgba(255, 255, 255, 0.60)",
            "55%": "rgba(255, 255, 255, 0.55)",
            "50%": "rgba(255, 255, 255, 0.50)",
            "40%": "rgba(255, 255, 255, 0.40)",
            "30%": "rgba(255, 255, 255, 0.30)",
            "25%": "rgba(255, 255, 255, 0.25)",
            "20%": "rgba(255, 255, 255, 0.20)",
            "15%": "rgba(255, 255, 255, 0.15)",
            "10%": "rgba(255, 255, 255, 0.10)",
            "8%": "rgba(255, 255, 255, 0.08)",
            "6%": "rgba(255, 255, 255, 0.06)",
            "4%": "rgba(255, 255, 255, 0.04)",
            "white": {
                "100%": "rgba(255, 255, 255, 1.00)",
                "80%": "rgba(255, 255, 255, 0.80)",
                "70%": "rgba(255, 255, 255, 0.70)",
                "50%": "rgba(255, 255, 255, 0.50)",
                "30%": "rgba(255, 255, 255, 0.30)",
                "20%": "rgba(255, 255, 255, 0.20)"
            },
            "black": {
                "100%": "rgba(0, 0, 0, 1.00)",
                "95%": "rgba(0, 0, 0, 0.95)",
                "80%": "rgba(0, 0, 0, 0.80)",
                "50%": "rgba(0, 0, 0, 0.50)",
                "24%": "rgba(0, 0, 0, 0.24)",
                "16%": "rgba(0, 0, 0, 0.16)",
                "10%": "rgba(0, 0, 0, 0.10)"
            },
            "inverted": {
                "100%": "rgba(0, 0, 0, 1.00)",
                "90%": "rgba(0, 0, 0, 0.90)"
            }
        },
        "vCS": {
            "backgroundAnimation": {
                "movingHightlights": {
                    "blob1": {
                        "start": "rgba(25, 240, 70, 0.85)",
                        "end": "rgba(0, 200, 120, 0.30)"
                    },
                    "blob2": {
                        "start": "rgba(0, 210, 170, 0.75)",
                        "end": "rgba(25, 240, 70, 0.25)"
                    },
                    "blob3": {
                        "start": "rgba(80, 230, 60, 0.70)",
                        "end": "rgba(160, 240, 50, 0.20)"
                    },
                    "blob4": {
                        "start": "rgba(0, 180, 160, 0.60)",
                        "end": "rgba(40, 220, 100, 0.30)"
                    },
                    "blob5": "rgba(0, 255, 180, 0.65)",
                    "blob6": "rgba(20, 160, 80, 0.25)"
                }
            }
        }
    }
}